<template>
  <div class="login-page">
    <Header />
    <div class="login-container">
      <div class="login-box">
        <h1 class="login-title">Área Restrita</h1>
        <p class="login-subtitle">Faça login para acessar o painel administrativo</p>
        
        <form @submit.prevent="fazerLogin" class="login-form">
          <div class="form-group">
            <label for="username">Usuário</label>
            <input
              id="username"
              v-model="username"
              type="text"
              class="form-input"
              placeholder="Digite seu usuário"
              required
            />
          </div>
          
          <div class="form-group">
            <label for="senha">Senha</label>
            <input
              id="senha"
              v-model="senha"
              type="password"
              class="form-input"
              placeholder="Digite sua senha"
              required
            />
          </div>
          
          <div v-if="erro" class="error-message">
            {{ erro }}
          </div>
          
          <button type="submit" class="btn-login" :disabled="carregando">
            {{ carregando ? 'Entrando...' : 'Entrar' }}
          </button>
        </form>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import authService from '../services/authService'

export default {
  name: 'Login',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      username: '',
      senha: '',
      erro: null,
      carregando: false
    }
  },
  mounted() {
    if (authService.isAuthenticated()) {
      this.$router.push('/admin')
    }
  },
  methods: {
    async fazerLogin() {
      this.erro = null
      this.carregando = true
      
      try {
        await authService.login(this.username, this.senha)
        this.$router.push('/admin')
      } catch (error) {
        this.erro = error.response?.data?.mensagem || 'Usuário ou senha inválidos'
      } finally {
        this.carregando = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 200px);
  padding: 40px 20px;
}

.login-box {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 100%;
  max-width: 400px;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 8px;
  text-align: center;
}

.login-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 32px;
  text-align: center;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}

.form-input {
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: #34894d;
  box-shadow: 0 0 0 3px rgba(52, 137, 77, 0.1);
}

.error-message {
  background: #fee2e2;
  color: #dc2626;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
}

.btn-login {
  background: #34894d;
  color: white;
  border: none;
  padding: 14px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 8px;
}

.btn-login:hover:not(:disabled) {
  background: #2d7a42;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(52, 137, 77, 0.2);
}

.btn-login:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>

